// extracted by mini-css-extract-plugin
module.exports = {"main":"FeedbackReportPage_main__2QUWI","tabs":"FeedbackReportPage_tabs__g_nf2"};